import * as React from 'react'

import { Image, ImageProps } from '@chakra-ui/react'

type Props = ImageProps & {
  fallbackSrc: string
}

// chakra v3 の Image には fallbackSrc が無いため、読み込み失敗時に差し替える
export const FallbackImage: React.FC<Props> = ({
  src,
  fallbackSrc,
  ...props
}) => {
  const [failed, setFailed] = React.useState(false)
  React.useEffect(() => {
    setFailed(false)
  }, [src])

  const showFallback = failed || src === undefined || src === ''
  return (
    <Image
      {...props}
      onError={(): void => {
        setFailed(true)
      }}
      src={showFallback ? fallbackSrc : src}
    />
  )
}
